[
  {
    "version": "v2.8.0",
    "features": [
      {
        "id": "zeeho-new-62-cast",
        "category": "update",
        "title": {
          "zh": "支持极核新款屏幕",
          "en": "Support for new ZEEHO screens"
        },
        "description": {
          "zh": "新增极核新款6.2英寸仪表投屏与5英寸屏幕连接支持，适配投屏画面比例。",
          "en": "Adds casting support for new ZEEHO 6.2-inch dashboards and connection support for new 5-inch screens, with adapted casting proportions."
        }
      },
      {
        "id": "fardriver-settings",
        "category": "update",
        "title": {
          "zh": "新增远驱参数设置",
          "en": "FarDriver settings"
        },
        "description": {
          "zh": "支持在 App 内查看和调整适用设备的参数，常用设置更好找。",
          "en": "View and adjust settings for compatible FarDriver devices, with everyday options easier to find."
        }
      },
      {
        "id": "battery-temperature",
        "category": "update",
        "title": {
          "zh": "记录更多电池温度",
          "en": "More battery temperatures"
        },
        "description": {
          "zh": "支持记录更多温度变化，骑行时和回看行程时都能了解电池状态。",
          "en": "Record more temperature readings to follow your battery during a ride and when looking back."
        }
      },
      {
        "id": "ride-photo-poster",
        "category": "update",
        "title": {
          "zh": "用照片分享骑行",
          "en": "Share your ride in a photo"
        },
        "description": {
          "zh": "将沿途照片与骑行记录合成海报，支持横图、竖图与方图；通过点阵调色盘调整色彩，在悬浮操作区完成调色、拍摄、保存和分享。",
          "en": "Combine photos and ride records into landscape, portrait, or square posters. Adjust colors with a dot-grid palette, with floating controls for color, capture, save, and share."
        }
      },
      {
        "id": "bms-connection",
        "category": "optimization",
        "title": {
          "zh": "连接更快和更稳定",
          "en": "Faster and more stable connections"
        },
        "description": {
          "zh": "减少启动后的连接等待，提升保护板与蓝牙设备的连接稳定性，改善蓝宝设备自动连接及断开后的重连体验。",
          "en": "Reduces connection delays after launch, improves BMS and Bluetooth device connection stability, and refines Bluebabe automatic connection and reconnection."
        }
      },
      {
        "id": "home-refresh",
        "category": "optimization",
        "title": {
          "zh": "首页与界面优化",
          "en": "Home screen and interface improvements"
        },
        "description": {
          "zh": "整理首页卡片与设备状态，完善深色界面及页面细节，让常用信息更清楚、操作更顺手。",
          "en": "Refines home screen cards, device status, dark appearance, and interface details to make everyday information and actions clearer."
        }
      },
      {
        "id": "ride-map",
        "category": "optimization",
        "title": {
          "zh": "更直观地回顾路线",
          "en": "A clearer view of your route"
        },
        "description": {
          "zh": "地图与骑行数据一起看，路线细节更丰富，回顾行程更方便。",
          "en": "See your map and ride data together, with more route detail for easier ride reviews."
        }
      },
      {
        "id": "su7-refresh",
        "category": "optimization",
        "title": {
          "zh": "SU7 仪表体验优化",
          "en": "SU7 dashboard improvements"
        },
        "description": {
          "zh": "更新开场动效与光效，调整读数和标识布局，让加速动画更流畅。",
          "en": "Refines opening and lighting effects, adjusts readings and logo placement, and makes acceleration animations smoother."
        }
      },
      {
        "id": "ui-refinements",
        "category": "optimization",
        "title": {
          "zh": "发现页与投屏教程优化",
          "en": "Discovery and casting guide improvements"
        },
        "description": {
          "zh": "完善极核投屏使用教程，优化发现页卡片与详情页的展开、返回动画，保持图片比例和浏览状态。",
          "en": "Improves the ZEEHO casting guide and discovery card transitions when opening and returning from details, preserving image proportions and browsing state."
        }
      },
      {
        "id": "overlay-display",
        "category": "fix",
        "title": {
          "zh": "修复悬浮窗显示",
          "en": "Ride overlay display fix"
        },
        "description": {
          "zh": "修复悬浮窗单指标模式下显示空白的问题。",
          "en": "Fixes blank readings in the ride overlay single-metric mode."
        }
      },
      {
        "id": "dianling-power-fix",
        "category": "fix",
        "title": {
          "zh": "修复电岭不显示功率",
          "en": "Dianling power display fix"
        },
        "description": {
          "zh": "修复电岭不显示功率。",
          "en": "Fixes missing power readings for Dianling controllers."
        }
      },
      {
        "id": "speed-calibration",
        "category": "fix",
        "title": {
          "zh": "修复时速校准",
          "en": "Speed calibration fix"
        },
        "description": {
          "zh": "修复部分情况下时速校准进度无法正常推进的问题。",
          "en": "Fixes an issue that could prevent speed calibration from progressing."
        }
      },
      {
        "id": "ride-export",
        "category": "fix",
        "title": {
          "zh": "修复骑行记录导出",
          "en": "Ride export fix"
        },
        "description": {
          "zh": "修复较长骑行记录可能导出失败的问题。",
          "en": "Fixes an issue that could stop longer rides from exporting."
        }
      },
      {
        "id": "ui-energy-fixes",
        "category": "fix",
        "title": {
          "zh": "修复蓝宝能耗计算",
          "en": "Bluebabe energy calculation fix"
        },
        "description": {
          "zh": "修复蓝宝能耗计算错误。",
          "en": "Fixes incorrect energy calculations for Bluebabe devices."
        }
      },
      {
        "id": "jk-protocol-fix",
        "category": "fix",
        "title": {
          "zh": "极空协议修正",
          "en": "JK BMS protocol fixes"
        },
        "description": {
          "zh": "修正JK02容量映射，使用设备设置中的额定容量，并结合电量百分比计算剩余容量，改善容量数据显示。",
          "en": "Corrects JK02 capacity mapping using rated capacity from device settings and state of charge to calculate remaining capacity."
        }
      }
    ]
  },
  {
    "version": "v2.7.0",
    "features": [
      {
        "id": "ride-community",
        "category": "update",
        "title": {
          "zh": "骑行榜与加速榜",
          "en": "Ride and acceleration rankings"
        },
        "description": {
          "zh": "支持搜索、条件筛选及今日、本周、本月、今年查询；可查看用户总览、单次成绩和我的记录。",
          "en": "Search, filter and view today, this week, this month or this year. Explore rider totals, individual results and your records."
        }
      },
      {
        "id": "su7-dashboard",
        "category": "update",
        "title": {
          "zh": "全新 SU7 Ultra 仪表",
          "en": "New SU7 Ultra dashboard"
        },
        "description": {
          "zh": "金色仪表搭配动态光效，可自由选择静止、标准、加速状态；提供续航、平均能耗和手机状态，停车可查看骑行信息与路线。底部显示 App 标识、设备异常和投屏提示。",
          "en": "A golden dashboard with animated lighting offers idle, standard and acceleration views. See range, average energy use and phone status, and review ride information and routes when stopped. The footer shows app branding, device warnings and casting messages."
        }
      },
      {
        "id": "theme-import",
        "category": "update",
        "title": {
          "zh": "导入与管理仪表主题",
          "en": "Import and manage dashboard themes"
        },
        "description": {
          "zh": "支持文件和局域网导入、扫码获取地址及安装前预览，可使用主题自带的设置页；长按确认后删除对应主题版本，其他版本与内置主题保留。",
          "en": "Import themes from files or your local network, scan an address and preview before installation. Use settings provided by a theme. Long-press and confirm to delete that version while keeping other versions and built-in themes."
        }
      },
      {
        "id": "mingtang-bms",
        "category": "update",
        "title": {
          "zh": "明唐保护板支持",
          "en": "MingTang BMS support"
        },
        "description": {
          "zh": "新增明唐保护板连接与数据展示，可查看和修改参数、确认保存结果，并导出历史和事件记录。",
          "en": "Connect MingTang battery management systems, view data, change settings, confirm saved changes, and export history and event records."
        }
      },
      {
        "id": "xinda-controller",
        "category": "update",
        "title": {
          "zh": "昕达控制器支持",
          "en": "Xinda controller support"
        },
        "description": {
          "zh": "新增昕达控制器识别与连接，可读取设备参数，并在骑行中查看速度、电压、功率及温度等数据。",
          "en": "Discover and connect Xinda controllers, read device parameters, and view speed, voltage, power and temperature while riding."
        }
      },
      {
        "id": "spd-controller",
        "category": "update",
        "title": {
          "zh": "好盈 SPD 控制器支持",
          "en": "Hobbywing SPD controller support"
        },
        "description": {
          "zh": "连接后自动读取实时数据、车辆信息、运行状态和故障，可查看油门开度、档位与温度；数据同步用于骑行仪表、历史记录和导出。",
          "en": "Automatically read live data, vehicle information, operating status and faults on connection. View throttle position, gear and temperatures in device details, ride dashboards, history and exports."
        }
      },
      {
        "id": "jh-controller",
        "category": "update",
        "title": {
          "zh": "晶汇控制器支持",
          "en": "Jinghui controller support"
        },
        "description": {
          "zh": "新增晶汇控制器连接，自动读取实时数据和设备参数，支持手动刷新；电压、电流、功率与温度用于骑行显示和能耗统计。",
          "en": "Connect Jinghui controllers, automatically read live data and device parameters, and refresh them manually. Voltage, current, power and temperatures feed ride displays and energy statistics."
        }
      },
      {
        "id": "ant-bms",
        "category": "update",
        "title": {
          "zh": "蚂蚁状态参数与备用通道",
          "en": "ANT BMS status and alternate channels"
        },
        "description": {
          "zh": "补全运行、连接、通信状态，保护故障、提示及硬件和软件版本；默认通道之外新增两组备用通道，选择按设备保存，连接失败时可直接切回默认通道。",
          "en": "View operating, connection and communication status, protection faults, messages, and hardware and software versions. Choose from two alternate channels alongside the default; choices save per device and can be switched back after a failed connection."
        }
      },
      {
        "id": "cfmoto-vehicle",
        "category": "update",
        "title": {
          "zh": "极核车辆连接与骑行数据",
          "en": "ZEEHO vehicle connections and ride data"
        },
        "description": {
          "zh": "时速、电量、电压、电池温度与续航显示在骑行仪表，车辆续航不可用时自动使用估算值。",
          "en": "Vehicle speed, battery level, voltage, battery temperature and range appear in ride dashboards, with estimated range as a fallback."
        }
      },
      {
        "id": "system-appearance",
        "category": "update",
        "title": {
          "zh": "深浅色与悬浮骑行",
          "en": "System appearance and ride overlay"
        },
        "description": {
          "zh": "App 可跟随系统切换深浅色；悬浮窗及预览可独立选择跟随系统、浅色或深色，默认跟随系统，预览切换更柔和。",
          "en": "The app can follow system appearance. The ride overlay and preview can independently follow the system or use light or dark colors, with system appearance as the default and gentle preview transitions."
        }
      },
      {
        "id": "history-safety",
        "category": "fix",
        "title": {
          "zh": "骑行记录与备份完整性",
          "en": "Ride record and backup integrity"
        },
        "description": {
          "zh": "修复记录读取、恢复时漏读和重复覆盖的问题，保留历史、轨迹、加速记录与未完成草稿，导出和备份更可靠。",
          "en": "Fix missing data and unintended overwrites when reading and restoring records. Preserve history, routes, acceleration records and unfinished drafts, with more reliable export and backup."
        }
      },
      {
        "id": "bluetooth-permission",
        "category": "fix",
        "title": {
          "zh": "蓝牙扫描权限兼容",
          "en": "Bluetooth scanning compatibility"
        },
        "description": {
          "zh": "修复部分手机授权后仍无法扫描设备的问题，完善蓝牙与定位权限提示及拒绝授权后的处理。",
          "en": "Fix scanning failures on some phones after permission approval, with clearer Bluetooth and location prompts and recovery after denial."
        }
      },
      {
        "id": "bluetooth-recovery",
        "category": "fix",
        "title": {
          "zh": "蓝牙连接与断线恢复",
          "en": "Bluetooth connections and recovery"
        },
        "description": {
          "zh": "修复暂停后断线无法恢复、旧连接状态残留等问题；连接失败后重新扫描可及时结束旧重连，重新选择设备。",
          "en": "Fix recovery after disconnection while paused and stale connection status. Scanning again after a failed connection stops previous retries so you can select a device again."
        }
      },
      {
        "id": "zhike-speed",
        "category": "fix",
        "title": {
          "zh": "智科刹车时速显示",
          "en": "Zhike speed display while braking"
        },
        "description": {
          "zh": "修复刹车减速时速度卡住、停车后迟迟不归零的问题；仍在转动时持续显示实际减速，停车后及时确认零速。",
          "en": "Fix speed freezing during braking and delayed zero-speed readings after stopping. Show actual deceleration while moving and confirm zero speed promptly when stopped."
        }
      },
      {
        "id": "app-stability",
        "category": "fix",
        "title": {
          "zh": "减少意外闪退",
          "en": "Fewer unexpected crashes"
        },
        "description": {
          "zh": "修复速度自动校准时缺少 GPS 样本、扫描期间关闭蓝牙等场景下的闪退，提升连接切换和恢复过程的稳定性。",
          "en": "Fix crashes caused by missing GPS samples during automatic speed calibration or turning Bluetooth off while scanning. Improve stability when switching and recovering connections."
        }
      },
      {
        "id": "casting-stability",
        "category": "fix",
        "title": {
          "zh": "手机投屏显示稳定性",
          "en": "Phone casting display stability"
        },
        "description": {
          "zh": "修复部分手机投屏布局异常、内容尺寸不合适及退出时闪退的问题，提升默认仪表在不同屏幕尺寸下的显示稳定性。",
          "en": "Fix casting layout errors, incorrect content sizing and crashes on exit on some phones, improving the default dashboard across different screen sizes."
        }
      },
      {
        "id": "fardriver-compatibility",
        "category": "optimization",
        "title": {
          "zh": "远驱控制器兼容与显示",
          "en": "FarDriver compatibility and readings"
        },
        "description": {
          "zh": "适配更多远驱系列控制器，完善温度、油门开度和档位显示，减少无效数据与反复断连；支持按设备保存兼容模式。",
          "en": "Support more FarDriver controller variants. Improve temperature, throttle and gear readings, reduce invalid values and repeated disconnections, and save compatibility modes per device."
        }
      },
      {
        "id": "controller-auth",
        "category": "optimization",
        "title": {
          "zh": "雁鑫 X500 连接与密码支持",
          "en": "Yanxin X500 connections and passwords"
        },
        "description": {
          "zh": "完善雁鑫 X500 连接兼容，支持需要密码时输入、记住和忘记密码，连接失败原因更清楚。",
          "en": "Improve X500 connection compatibility and support entering, remembering and forgetting a device password, with clearer connection failure messages."
        }
      },
      {
        "id": "smooth-speed",
        "category": "optimization",
        "title": {
          "zh": "时速持续平滑显示",
          "en": "Continuous smooth speed display"
        },
        "description": {
          "zh": "优化控制器与 GPS 时速的连续过渡，减少速度突变、停顿和反复卡顿，骑行记录保留实际测量数据。",
          "en": "Improve continuous controller and GPS speed transitions, reducing sudden catch-up, pauses and repeated stuttering. Recorded measurements remain unchanged."
        }
      },
      {
        "id": "record-storage",
        "category": "optimization",
        "title": {
          "zh": "骑行记录更省空间",
          "en": "Smaller ride record storage"
        },
        "description": {
          "zh": "减少记录长期空间占用，提升详情读取效率；旧记录整理后保留完整数据和导出内容。",
          "en": "Reduce long-term record storage and speed up detail views. Organizing older records preserves complete data and exports."
        }
      },
      {
        "id": "ride-cards",
        "category": "optimization",
        "title": {
          "zh": "骑行卡片与仪表预览",
          "en": "Ride cards and dashboard previews"
        },
        "description": {
          "zh": "骑行卡片采用更通透的白、蓝、橙配色，展开与回拉更流畅；默认主题预览同步当前配色、背景与指标配置。",
          "en": "Ride cards use clearer translucent white, blue and orange colors with smoother expansion and collapse. Default theme previews show your current colors, background and metrics."
        }
      },
      {
        "id": "account-interface",
        "category": "optimization",
        "title": {
          "zh": "登录与车辆资料页面",
          "en": "Sign-in and vehicle profile pages"
        },
        "description": {
          "zh": "重新设计登录、注册、找回账号和车辆资料页面，新增插画与柔和动效，表单更清楚，小屏操作更方便。",
          "en": "Redesigned sign-in, registration, account recovery and vehicle profile pages add illustrations, gentle motion and clearer forms for smaller screens."
        }
      },
      {
        "id": "navigation",
        "category": "optimization",
        "title": {
          "zh": "导航与设备切换",
          "en": "Navigation and device switching"
        },
        "description": {
          "zh": "统一首页、设备、骑行、设置入口，整理高级设置，充电器连接支持协议选择；多设备切换栏统一样式，超过三台时露出下一项，选中后自动滚动到完整可见。",
          "en": "Use consistent Home, Devices, Ride and Settings tabs, organized advanced settings and protocol selection for chargers. Device tabs share one style, reveal the next item when there are more than three devices, and scroll the selected item fully into view."
        }
      },
      {
        "id": "vehicle-connection",
        "category": "optimization",
        "title": {
          "zh": "车辆连接与数据页面",
          "en": "Vehicle connection and data pages"
        },
        "description": {
          "zh": "车辆连接操作与保护板、控制器页面统一，长说明收进弹窗；连接资料随车辆保存，重连无需重复输入。按车辆展示参数，电量使用状态条，隐藏缺失数据和空卡片。",
          "en": "Vehicle connection controls match BMS and controller pages, with longer explanations in a sheet. Save connection details per vehicle for reuse. Show vehicle-specific data and a battery bar while hiding missing values and empty cards."
        }
      },
      {
        "id": "theme-settings",
        "category": "optimization",
        "title": {
          "zh": "仪表布局与主题设置",
          "en": "Dashboard layout and theme settings"
        },
        "description": {
          "zh": "SU7 横屏时速、两侧数据和光晕更清晰；横屏四格、竖屏八格直接选择指标，支持留空与分别保存。默认主题背景支持 8 MB 图片。",
          "en": "SU7 landscape speed, side readings and lighting are clearer. Choose metrics in four landscape slots or eight portrait slots, leave them empty and save each layout separately. Default theme backgrounds support 8 MB images."
        }
      },
      {
        "id": "vehicle-gear",
        "category": "optimization",
        "title": {
          "zh": "仪表挡位与驻车状态",
          "en": "Dashboard gear and parking status"
        },
        "description": {
          "zh": "Race LED Pro 可显示极核真实挡位与 P 状态，解除 P 后显示低、中、高挡。",
          "en": "Race LED Pro shows actual ZEEHO gear and parking state. After leaving P, it shows low, medium or high gear."
        }
      },
      {
        "id": "startup-experience",
        "category": "optimization",
        "title": {
          "zh": "启动速度与入场动画",
          "en": "Startup speed and entrance animation"
        },
        "description": {
          "zh": "加快进入首页，减少启动等待与画面跳变；入场采用自下而上的柔光扫过，适配深浅色和横竖屏。",
          "en": "Reach Home faster with less waiting and fewer visual jumps. A soft upward light sweep introduces the app and adapts to light, dark, portrait and landscape views."
        }
      },
      {
        "id": "casting-controls",
        "category": "optimization",
        "title": {
          "zh": "手机投屏操作",
          "en": "Phone casting controls"
        },
        "description": {
          "zh": "投屏来源简化为跟随主题与屏幕投屏，切换主题和方向更统一；配对弹窗打开 1 秒后显示确认按钮，减少等待。",
          "en": "Choose Follow theme or Screen casting with consistent theme and orientation controls. The pairing sheet shows its confirmation button after one second to reduce waiting."
        }
      },
      {
        "id": "connection-guide",
        "category": "optimization",
        "title": {
          "zh": "更清楚的首次连接引导",
          "en": "Clearer first-time connection guide"
        },
        "description": {
          "zh": "重新设计保护板、控制器连接和最后确认页面，扫描、协议选择与支持设备列表更清楚；自动推荐仪表数据来源，车辆数据统一从“车辆”入口选择。",
          "en": "Redesigned BMS, controller and final setup pages make scanning, protocol selection and supported devices clearer. Dashboard data sources are recommended automatically, with all vehicle data available under Vehicle."
        }
      },
      {
        "id": "short-rides",
        "category": "optimization",
        "title": {
          "zh": "短骑行自动整理",
          "en": "Automatic short-ride cleanup"
        },
        "description": {
          "zh": "不足 1 分钟的新骑行默认进入回收站，3 天内可找回；退出时可选择继续记录或主动保存，让历史列表更整洁。",
          "en": "New rides shorter than one minute go to the recycle bin by default and can be restored within three days. Continue recording or choose to save them when leaving, keeping your history tidy."
        }
      },
      {
        "id": "refresh-display",
        "category": "optimization",
        "title": {
          "zh": "刷新与显示统一设置",
          "en": "Refresh and display settings together"
        },
        "description": {
          "zh": "在骑行数据来源中集中设置蓝牙更新速度、即时或平滑时速、低性能模式及超时显示，配合时速示意预览，调整更直观。",
          "en": "Set Bluetooth update speed, immediate or smooth speed display, low-performance mode and timeout display together under ride data sources. A speed preview makes adjustments easier to understand."
        }
      }
    ]
  },
  {
    "version": "v2.5.0",
    "features": [
      {
        "id": "feedback",
        "category": "update",
        "title": {
          "zh": "应用内问题与建议反馈",
          "en": "In-app feedback"
        },
        "description": {
          "zh": "新增问题反馈与功能建议流程，可直接在应用内提交并查看处理进度。",
          "en": "Submit issues and feature requests in the app and track their progress."
        }
      },
      {
        "id": "history-map",
        "category": "update",
        "title": {
          "zh": "骑行历史地图",
          "en": "Ride history maps"
        },
        "description": {
          "zh": "骑行历史新增地图轨迹展示，便于回顾行程。",
          "en": "Review recorded routes on a map."
        }
      },
      {
        "id": "record-composition",
        "category": "update",
        "title": {
          "zh": "骑行记录合并与拆分",
          "en": "Merge and split rides"
        },
        "description": {
          "zh": "支持合并多段骑行记录，以及按片段拆分查看。",
          "en": "Combine multiple ride records or inspect individual segments."
        }
      },
      {
        "id": "phone-metrics",
        "category": "update",
        "title": {
          "zh": "手机温度与电量组件",
          "en": "Phone temperature and battery"
        },
        "description": {
          "zh": "骑行仪表新增手机温度和手机电量组件。",
          "en": "Add phone temperature and battery indicators to the ride dashboard."
        }
      },
      {
        "id": "duration",
        "category": "update",
        "title": {
          "zh": "骑行时长显示",
          "en": "Hours and minutes"
        },
        "description": {
          "zh": "骑行超过一小时后，时长按“小时 / 分钟”显示。",
          "en": "Ride duration switches to hours and minutes after one hour."
        }
      },
      {
        "id": "record-extrema",
        "category": "update",
        "title": {
          "zh": "骑行记录参数摘要",
          "en": "Record minimums and maximums"
        },
        "description": {
          "zh": "记录摘要展示参数最大值与最小值，替代首帧读数。",
          "en": "Record summaries show minimum and maximum values instead of the first sample."
        }
      },
      {
        "id": "animation-settings",
        "category": "update",
        "title": {
          "zh": "统一加速动画设置",
          "en": "Unified acceleration animation settings"
        },
        "description": {
          "zh": "统一骑行加速动画的触发与效果设置，支持预览。",
          "en": "Configure and preview acceleration animation triggers and effects in one place."
        }
      },
      {
        "id": "screen-lock",
        "category": "update",
        "title": {
          "zh": "骑行息屏模式",
          "en": "Ride screen lock"
        },
        "description": {
          "zh": "骑行模式新增黑屏锁定，减少屏幕干扰。",
          "en": "A black-screen lock reduces screen distraction during rides."
        }
      },
      {
        "id": "range",
        "category": "update",
        "title": {
          "zh": "续航预估",
          "en": "Remaining range estimate"
        },
        "description": {
          "zh": "骑行模式新增剩余续航预估组件。",
          "en": "View estimated remaining range in the ride dashboard."
        }
      },
      {
        "id": "four-tabs",
        "category": "update",
        "title": {
          "zh": "四项底部导航",
          "en": "Four-tab navigation"
        },
        "description": {
          "zh": "底部导航支持设置为四个入口。",
          "en": "Choose a four-entry bottom navigation layout."
        }
      },
      {
        "id": "yanyang",
        "category": "update",
        "title": {
          "zh": "彦阳保护板接入",
          "en": "Yanyang BMS support"
        },
        "description": {
          "zh": "可在设备连接页连接彦阳保护板，并用于骑行模式。",
          "en": "Connect a Yanyang BMS from Devices and use its data in ride mode."
        }
      },
      {
        "id": "theme-cast",
        "category": "update",
        "title": {
          "zh": "APP 主题直接投屏",
          "en": "Direct app-theme casting"
        },
        "description": {
          "zh": "极核投屏选择 APP 主题编码器后，进入骑行可自动投屏，无需每次确认系统屏幕录制授权。",
          "en": "Select the app-theme encoder to cast when entering ride mode without repeated system screen-recording permission prompts."
        }
      },
      {
        "id": "cast-firmware",
        "category": "fix",
        "title": {
          "zh": "极核新固件兼容",
          "en": "New instrument firmware compatibility"
        },
        "description": {
          "zh": "修复极核仪表新固件下投屏闪退的问题。",
          "en": "Fix casting crashes with newer instrument firmware."
        }
      },
      {
        "id": "landscape-start",
        "category": "fix",
        "title": {
          "zh": "横屏启动布局",
          "en": "Landscape startup layout"
        },
        "description": {
          "zh": "修复横屏进入应用时的布局异常。",
          "en": "Fix incorrect layout when the app starts in landscape."
        }
      },
      {
        "id": "protocol-switch",
        "category": "fix",
        "title": {
          "zh": "连接组协议切换",
          "en": "Connection-group protocol switching"
        },
        "description": {
          "zh": "修复切换连接组后蓝牙协议未同步切换的问题。",
          "en": "Switch the Bluetooth protocol together with the selected connection group."
        }
      },
      {
        "id": "resume",
        "category": "fix",
        "title": {
          "zh": "返回应用稳定性",
          "en": "Reliable app resume"
        },
        "description": {
          "zh": "修复从后台返回应用时可能出现的异常。",
          "en": "Fix errors that could occur when returning to the app."
        }
      },
      {
        "id": "controller-speed",
        "category": "fix",
        "title": {
          "zh": "控制器时速显示",
          "en": "Controller speed display"
        },
        "description": {
          "zh": "修复部分控制器在首页不显示时速，以及控制器时速与 GPS 数据冲突的问题。",
          "en": "Fix missing controller speed on Home and conflicts between controller and GPS speed."
        }
      },
      {
        "id": "resume-signals",
        "category": "fix",
        "title": {
          "zh": "后台连接与定位恢复",
          "en": "Restore Bluetooth and GPS"
        },
        "description": {
          "zh": "修复返回应用后蓝牙无法重连、GPS 信号丢失的问题。",
          "en": "Fix Bluetooth reconnection and GPS signal loss after resuming the app."
        }
      },
      {
        "id": "device-list",
        "category": "fix",
        "title": {
          "zh": "蓝牙设备列表",
          "en": "Bluetooth device list"
        },
        "description": {
          "zh": "修复设备连接页异常及扫描结果筛选问题。",
          "en": "Fix connection-page errors and incorrect filtering of scan results."
        }
      },
      {
        "id": "long-record-crash",
        "category": "fix",
        "title": {
          "zh": "超长记录返回",
          "en": "Leaving long ride records"
        },
        "description": {
          "zh": "修复查看超长骑行记录后返回时可能闪退的问题。",
          "en": "Fix crashes when returning from very long ride records."
        }
      },
      {
        "id": "statusbar-white",
        "category": "fix",
        "title": {
          "zh": "顶部状态栏颜色",
          "en": "Status-bar colors"
        },
        "description": {
          "zh": "修复顶部状态栏意外变白的问题。",
          "en": "Fix the top status bar unexpectedly turning white."
        }
      },
      {
        "id": "oneplus",
        "category": "fix",
        "title": {
          "zh": "部分手机仪表显示",
          "en": "Dashboard compatibility"
        },
        "description": {
          "zh": "修复一加等手机在骑行模式下参数显示异常的问题。",
          "en": "Fix incorrect ride-parameter display on OnePlus and other affected phones."
        }
      },
      {
        "id": "lingbo",
        "category": "fix",
        "title": {
          "zh": "凌博读数稳定性",
          "en": "Stable Lingbo readings"
        },
        "description": {
          "zh": "修复凌博控制器在骑行模式下读数短暂闪零的问题。",
          "en": "Fix Lingbo ride readings briefly dropping to zero."
        }
      },
      {
        "id": "datai",
        "category": "fix",
        "title": {
          "zh": "大泰连接稳定性",
          "en": "Datai connection stability"
        },
        "description": {
          "zh": "修复部分大泰控制器连接后断开的问题。",
          "en": "Fix disconnects affecting some Datai controllers."
        }
      },
      {
        "id": "fardriver",
        "category": "fix",
        "title": {
          "zh": "远驱兼容性",
          "en": "Fardriver compatibility"
        },
        "description": {
          "zh": "修复远驱控制器可能引发的闪退及温度缺失问题。",
          "en": "Fix potential crashes and missing temperature data with Fardriver controllers."
        }
      },
      {
        "id": "cast-layout",
        "category": "optimization",
        "title": {
          "zh": "极核投屏渲染布局",
          "en": "Casting renderer layout"
        },
        "description": {
          "zh": "调整极核投屏渲染器的排版与信息层级。",
          "en": "Refine the casting renderer layout and information hierarchy."
        }
      },
      {
        "id": "source-preview",
        "category": "optimization",
        "title": {
          "zh": "骑行数据源预览",
          "en": "Ride data-source preview"
        },
        "description": {
          "zh": "更新骑行数据源预览界面，便于检查数据来源与显示效果。",
          "en": "Refresh the data-source preview for inspecting sources and displayed readings."
        }
      },
      {
        "id": "backup",
        "category": "optimization",
        "title": {
          "zh": "备份与恢复",
          "en": "Backup and restore"
        },
        "description": {
          "zh": "增强备份导入、记录合并与大文件处理能力。",
          "en": "Improve backup imports, record merging and large-file handling."
        }
      },
      {
        "id": "statusbar",
        "category": "optimization",
        "title": {
          "zh": "顶部状态栏界面",
          "en": "Top status-bar interface"
        },
        "description": {
          "zh": "更新顶部状态栏样式与状态信息展示。",
          "en": "Refresh the top status-bar appearance and status information."
        }
      },
      {
        "id": "ride-copy",
        "category": "optimization",
        "title": {
          "zh": "骑行界面精简",
          "en": "Cleaner ride interface"
        },
        "description": {
          "zh": "移除骑行模式下部分辅助小字，突出关键参数。",
          "en": "Remove redundant helper text to emphasize key ride readings."
        }
      },
      {
        "id": "history-performance",
        "category": "optimization",
        "title": {
          "zh": "长记录加载速度",
          "en": "Faster long-record loading"
        },
        "description": {
          "zh": "优化长骑行记录的读取与预览，缩短打开等待时间。",
          "en": "Reduce waiting time when loading and previewing long ride records."
        }
      },
      {
        "id": "startup",
        "category": "optimization",
        "title": {
          "zh": "应用启动速度",
          "en": "Faster app startup"
        },
        "description": {
          "zh": "优化启动流程与资源加载，缩短应用打开时间。",
          "en": "Optimize startup and resource loading to open the app faster."
        }
      },
      {
        "id": "bluebabe",
        "category": "optimization",
        "title": {
          "zh": "蓝宝自动连接",
          "en": "Bluebabe automatic connection"
        },
        "description": {
          "zh": "移除匹配码安全保存流程，改为根据设备 MAC 地址自动连接。",
          "en": "Remove the matching-code storage flow and reconnect using the device MAC address."
        }
      },
      {
        "id": "cast-aspect",
        "category": "optimization",
        "title": {
          "zh": "内置编码器投屏比例",
          "en": "Built-in casting encoder aspect ratio"
        },
        "description": {
          "zh": "优化极核投屏内置编码器的显示比例。",
          "en": "Improve display proportions with the built-in casting encoder."
        }
      },
      {
        "id": "dark-mode",
        "category": "optimization",
        "title": {
          "zh": "深色模式适配",
          "en": "Dark-mode support"
        },
        "description": {
          "zh": "完善页面、组件和状态栏的深色模式显示。",
          "en": "Improve dark-mode rendering across pages, components and the status bar."
        }
      },
      {
        "id": "navigation",
        "category": "optimization",
        "title": {
          "zh": "页面切换响应",
          "en": "More responsive navigation"
        },
        "description": {
          "zh": "移除页面切换动画，提升导航响应速度。",
          "en": "Remove page transitions for quicker navigation."
        }
      },
      {
        "id": "huawei-cast",
        "category": "optimization",
        "title": {
          "zh": "华为投屏兼容",
          "en": "Huawei casting compatibility"
        },
        "description": {
          "zh": "改善华为手机使用极核投屏时的兼容性。",
          "en": "Improve casting compatibility on Huawei phones."
        }
      }
    ]
  },
  {
    "version": "v2.3.0",
    "features": [
      {
        "id": "apt-device-expansion",
        "title": {
          "zh": "更多 APT 设备适配",
          "en": "More APT device support"
        },
        "description": {
          "zh": "扩展更多 APT 设备适配，并新增 AUSI 控制器与第三方远驱 BLE 适配支持，连接识别更完整。",
          "en": "Expanded APT device coverage and added AUSI controller and third-party FarDriver BLE adapter support for broader connection compatibility."
        },
        "category": "update"
      },
      {
        "id": "liquid-glass-navigation",
        "title": {
          "zh": "液态玻璃底部导航",
          "en": "Liquid glass bottom navigation"
        },
        "description": {
          "zh": "底部导航栏焕新为液态玻璃风格，层级更清晰，切换更顺手。",
          "en": "The bottom navigation now uses a liquid-glass surface with clearer hierarchy and smoother interaction."
        },
        "category": "optimization"
      },
      {
        "id": "device-parameter-editor",
        "title": {
          "zh": "设备参数页更新",
          "en": "Updated device parameter page"
        },
        "description": {
          "zh": "重构设备参数页界面，支持编辑卡片顺序和显示状态，按习惯整理常用信息。",
          "en": "Refined the device parameter page with editable card order and visibility so frequently used data is easier to arrange."
        },
        "category": "optimization"
      },
      {
        "id": "page-transition-motion",
        "title": {
          "zh": "页面切换动画",
          "en": "Page transition motion"
        },
        "description": {
          "zh": "加入轻量页面切换动画，导航层级和页面转场更连贯。",
          "en": "Added lightweight page transitions to make navigation hierarchy and route changes feel more connected."
        },
        "category": "update"
      },
      {
        "id": "average-power-metric",
        "title": {
          "zh": "骑行平均功率",
          "en": "Average power for rides"
        },
        "description": {
          "zh": "骑行模式新增平均功率选项，方便观察一段骑行中的持续输出表现。",
          "en": "Ride mode now offers an average-power metric to help track sustained output during a ride."
        },
        "category": "update"
      },
      {
        "id": "gps-compatibility",
        "title": {
          "zh": "GPS 兼容性修复",
          "en": "GPS compatibility fixes"
        },
        "description": {
          "zh": "修复部分 OPPO 手机上的 GPS 定位异常，提升速度和轨迹数据的稳定性。",
          "en": "Fixed GPS issues on some OPPO phones to improve speed and route data stability."
        },
        "category": "fix"
      },
      {
        "id": "smaller-install-package",
        "title": {
          "zh": "安装包体积优化",
          "en": "Smaller install package"
        },
        "description": {
          "zh": "清理并压缩发布资源，优化安装包体积和首次下载体验。",
          "en": "Cleaned up and compressed release assets to reduce package size and improve the first download experience."
        },
        "category": "optimization"
      },
      {
        "id": "bluebabe-auto-connect",
        "title": {
          "zh": "蓝宝自动连接修复",
          "en": "Bluebabe auto-connect fix"
        },
        "description": {
          "zh": "解决蓝宝模块无法自动连接的问题，后台重连和设备恢复更可靠。",
          "en": "Fixed Bluebabe modules failing to reconnect automatically, making background recovery more reliable."
        },
        "category": "fix"
      },
      {
        "id": "suniu-ride-stability",
        "title": {
          "zh": "速牛骑行稳定性",
          "en": "Suniu ride stability"
        },
        "description": {
          "zh": "修复速牛控制器在骑行过程中的异常状态，提升实时数据连续性。",
          "en": "Fixed abnormal ride behavior with Suniu controllers and improved continuity of live data."
        },
        "category": "fix"
      },
      {
        "id": "jikong-bms-display",
        "title": {
          "zh": "极空保护板显示优化",
          "en": "Jikong BMS display improvements"
        },
        "description": {
          "zh": "优化极空保护板在骑行中可能变灰的问题，让状态显示更稳定。",
          "en": "Improved Jikong BMS handling so its status is less likely to turn gray while riding."
        },
        "category": "optimization"
      }
    ]
  },
  {
    "version": "v2.2.0",
    "features": [
      {
        "id": "bluebabe-module",
        "title": {
          "zh": "蓝宝模块连接",
          "en": "Bluebabe module connection"
        },
        "description": {
          "zh": "新增蓝宝模块连接支持，可在设备连接页完成匹配并读取兼容模块返回的电池状态。",
          "en": "Connect compatible Bluebabe modules from the device page and read the battery status reported by the module."
        },
        "category": "update"
      },
      {
        "id": "controller-expansion",
        "title": {
          "zh": "更多控制器连接",
          "en": "More controller connections"
        },
        "description": {
          "zh": "新增顿恩、APT、智科、速牛、大泰和雁鑫控制器连接适配。选择对应型号后，应用会按匹配协议建立只读连接并展示可用运行数据。",
          "en": "Adds read-only connection support for DN-DUNEN, APT, Zhike, Suniu, Datai, and Yanxin controllers, using the protocol matched to the selected model."
        },
        "category": "update"
      },
      {
        "id": "page-refinements",
        "title": {
          "zh": "页面体验优化",
          "en": "Refined page experience"
        },
        "description": {
          "zh": "优化部分页面细节与设备连接引导流程，整理设备连接页的布局和扫描操作，并补充清晰的重新扫描与断开入口。",
          "en": "Refines several page details and the guided device connection flow, with a clearer layout plus direct rescan and disconnect actions."
        },
        "category": "optimization"
      },
      {
        "id": "ride-speed-stability",
        "title": {
          "zh": "骑行时速显示优化",
          "en": "Stable ride speed display"
        },
        "description": {
          "zh": "修复部分设备在骑行过程中时速数值闪烁的问题，提升实时仪表显示的稳定性。",
          "en": "Fixes speed-value flicker seen with some devices while riding for a steadier live dashboard."
        },
        "category": "fix"
      }
    ]
  }
]
